import type { TourDefinition } from '@renderer/hooks/useTour';

/**
 * Sprint 48 — Tour de la pantalla de Propinas.
 * Flujo complejo: pozo → pendientes → reparto (3 pasos) → historial.
 * Términos técnicos explicados en lenguaje natural para el operador.
 */
export const tourPropinas: TourDefinition = {
  id: 'propinas',
  title: 'Cómo gestionar las propinas',
  steps: [
    {
      element: '[data-tour="propinas-pozo"]',
      popover: {
        title: '1. El pozo de propinas',
        description:
          'El "pozo" es el dinero de propinas que se ha cobrado pero aún no se ha repartido a los meseros. El monto y la cantidad de pagos se actualizan en tiempo real conforme llegan cobros con propina.',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="propinas-tabs"]',
      popover: {
        title: '2. Las tres pestañas',
        description:
          '"Pendientes" muestra qué propinas están sin asignar y a quién se atribuyen. "Hacer reparto" es donde calculas y ejecutas la distribución. "Histórico" guarda todos los repartos anteriores con su estado de entrega.',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="propinas-tabs"]',
      popover: {
        title: '3. Hacer un reparto',
        description:
          'En la pestaña "Hacer reparto": primero elige el PERÍODO (solo hoy, esta semana, últimos días o rango personalizado). Luego el CRITERIO: "por mesero" reparte según quién atendió cada pedido; "igualitario" divide en partes iguales entre los empleados que elijas.',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="propinas-tabs"]',
      popover: {
        title: '4. Vista previa antes de confirmar',
        description:
          'Antes de ejecutar el reparto, aparece una simulación con cuánto recibirá cada persona. Revísala con calma. Si algo no está bien, regresa y cambia el criterio o el período. Solo cuando confirmes se registra el reparto oficialmente.',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="propinas-tabs"]',
      popover: {
        title: '5. Historial y entrega',
        description:
          'En "Histórico" ves todos los repartos pasados. Cada uno tiene un estado: "Pendiente entrega" (ya calculado, falta entregar el efectivo) o "Entregado". Cuando le entregues el dinero a cada mesero, marca el checkbox correspondiente para dejar constancia.',
        side: 'bottom',
      },
    },
  ],
};
